

import { useDispatch, useSelector } from "react-redux";
import { formatDateLocal } from "../../lib/script";
import Button from "../common/Button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { tabs_button } from '../../assets/data'
import { notePriorityOptions, noteTypesOptions, retrieveAllWorkQs } from "../../lib/systemData";
import { workqueueActions } from "../../store/workqueue";
import { detailsActions } from "../../store/details";
import DaysDifference from "../patient/details/notes/DaysDifference";
import Tag from "../fragments/Tag";
import TaskMessages from "./TaskMessages";
import TaskAssignee from "./TaskAssignee";
import TaskSetFavorite from "./TaskSetFavorite";
import ResolveAndCreate from "../patient/details/notes/ResolveAndCreate";
import DeleteNote from "../patient/details/notes/DeleteNote";
import { isDeletedTask } from "../../lib/noteDelete";
import SimpleCopyTextButton from "../common/SimpleCopyTextButton";

import classes from './Tasks.module.css'
import PatientOrChart from "../patient/page/PatientOrChart";
import { isDateInThePast } from "../../lib/dateScripts";

export default function TasksRow({itemData, isInTab}) {
    
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);
    const user = useSelector(state => state.user.user)
 
    const [showResolveTask, setShowResolveTask] = useState(false)

    const openResolveTask = () => {
        setShowResolveTask(prevState => prevState = !prevState)
    }


    const goToCaseAndTab = () => {        
        let tab_index = 0;

        let note_type = noteTypesOptions()?.find(item => item.value == itemData.note_type_id)?.label
        tabs_button.forEach(item => {
            if (item.name == note_type) {
                tab_index = item.id
            }
        })

        // navigate(`/cases/${itemData.case.id}`)
        navigate(`/cases/${itemData.patient.person_number}`)
        dispatch(detailsActions.setActiveTab(tab_index))
    }

    return <>
        <tr className={classes.item}>
            <td className='table-cell-fit'>
                <TaskSetFavorite itemData={itemData} classes={classes}/>
            </td>
            <td>
                <SimpleCopyTextButton textToCopy={itemData?.patient?.person_number} />
                {/* {itemData?.patient?.person_number} */}
            </td>
            <td className="table-cell-no-padding">
                <div className={classes.name_cell}>
                <PatientOrChart item={itemData} color={'var(--white)'}/>
                    <Button btnStyle={'btn_simple'} click={goToCaseAndTab} title={'Go to case'}>
                        
                        {itemData?.patient?.name}
                    </Button>  
                </div>              
            </td>
            <td>
                {itemData.created_at && <>{formatDateLocal(itemData.created_at)}</>}
            </td>
            <td style={{width: 130}}>
                {itemData.user ? itemData.user.name : 'System'}                
            </td>
            <td className='table-cell-fit'>
                {itemData.note_type_id && noteTypesOptions()?.find(item => item.value == itemData.note_type_id)?.label}
            </td>
            <td>
                <TaskMessages itemData={itemData} classes={classes}/>
            </td>
            <td>
                {itemData.priority && <Tag type={notePriorityOptions().find(item => item.value == itemData.priority)?.color}>{itemData.priority}</Tag>}
            </td>
            <td>
                <TaskAssignee itemData={itemData} classes={classes}/>
            </td>
            <td className={`${classes.action_required} table-cell-fit`}>
                {/* {itemData.note_action ? itemData.note_action.name : '-'} */}
                {itemData.note_type_id && noteTypesOptions()?.find(item => item.value == itemData.note_type_id)?.note_actions?.find(item => item.id == itemData.note_action_id)?.name}
            </td>
            <td className={`table-cell-fit ${isDateInThePast(itemData.due_date) ? classes.red_cell : ''}`}>
                <div className="flex-container flex-container-space-betwen gap-5">
                    {itemData.due_date ? formatDateLocal(itemData.due_date) : '-'}
                    {/* {!itemData.assignee_resolved && <DaysDifference days={getDaysDifference(itemData.due_date)}/>} */}

                    {!itemData.assignee_resolved && !itemData.resolved ?  <>
                        <DaysDifference date={itemData.due_date}/>
                    </> : <>
                        {itemData.user?.id == user?.id && !itemData.resolved ? <>
                            <DaysDifference date={itemData.due_date}/>
                        </> : <></>}
                    </>}                    

                </div>
            </td>
            <td className='table-cell-fit'>
                <div className={`${classes.resove_cell} flex-container`}>
                    {!itemData.assignee_resolved && !itemData.resolved ?  <>
                        <Button click={openResolveTask} btnStyle={'btn_small'}>Resolve</Button>
                    </> : <></>}

                    {itemData.user?.id == user?.id && itemData.assignee_resolved && !itemData.resolved ? <>
                        <Button click={openResolveTask} btnStyle={'btn_small'}>Complete</Button>
                    </> : <></>}
                    {!isDeletedTask(itemData) && <DeleteNote itemData={itemData} />}
                </div>
            </td>           
        </tr>

        <ResolveAndCreate itemData={itemData} showResolveTask={showResolveTask} setShowResolveTask={() => setShowResolveTask(prevState => prevState = !prevState)} inTask={true} isTasksListing={true}/>
    </>
}